/** Curated staff-sidebar modules for seated resident board members. */
export const RESIDENT_BOARD_MAIN_ROUTE_KEYS = [
  "dars",
  "incidents",
  "propertyinspectionreport",
  "poolaccesslogs",
  "tennisaccesslogs",
  "gymaccesslogs",
  "recreationaccesslogs",
  "dispatchlogs",
] as const;

export const RESIDENT_BOARD_MANAGEMENT_ROUTE_KEYS = [
  "citations",
  "safelistings",
  "reportrequests",
] as const;

export const RESIDENT_BOARD_ROUTE_KEYS = [
  ...RESIDENT_BOARD_MAIN_ROUTE_KEYS,
  ...RESIDENT_BOARD_MANAGEMENT_ROUTE_KEYS,
] as const;

export type ResidentBoardRouteKey = (typeof RESIDENT_BOARD_ROUTE_KEYS)[number];

const RESIDENT_BOARD_ROUTE_KEY_SET = new Set<string>(RESIDENT_BOARD_ROUTE_KEYS);

export function isResidentBoardRouteKey(key: string | undefined): key is ResidentBoardRouteKey {
  return key != null && RESIDENT_BOARD_ROUTE_KEY_SET.has(key);
}

/** URL prefixes for board-module nav (keep aligned with `authenticated.tsx` paths for route keys above). */
export const RESIDENT_BOARD_MODULE_PATHS = [
  "/dars",
  "/incidents",
  "/property-inspection-reports",
  "/poolaccesslogs",
  "/tennisaccesslogs",
  "/gymaccesslogs",
  "/recreationaccesslogs",
  "/dispatchlogs",
  "/safelistings",
  "/citations",
  "/reportrequests",
] as const;

function normalizePathname(pathname: string): string {
  if (pathname.length > 1 && pathname.endsWith("/")) {
    return pathname.slice(0, -1);
  }
  return pathname;
}

export function isResidentBoardModulePath(pathname: string): boolean {
  const normalized = normalizePathname(pathname);
  return RESIDENT_BOARD_MODULE_PATHS.some(
    (path) => normalized === path || normalized.startsWith(`${path}/`),
  );
}
